import { render, staticRenderFns } from "./list_news.vue?vue&type=template&id=3bc474f2&scoped=true"
import script from "./list_news.vue?vue&type=script&lang=js"
export * from "./list_news.vue?vue&type=script&lang=js"
import style0 from "./list_news.vue?vue&type=style&index=0&id=3bc474f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc474f2",
  null
  
)

export default component.exports